import React, { useEffect } from 'react';
import loadable from '@loadable/component';
import SignupAndLoginMicroFrontend from '../MicroFrontend/SignupAndLogin';
import LoginAndRegisterPopUp from './LoginAndRegisterPopUp';
import AccountFlyout from './AccountFlyout';
import { ShopToClub, ShopToClubDoubleOptIn } from './ShopToClub';
import { OverlayId } from './types';
import { useOverlayStateChecker } from './useOverlayStateChecker';
import useOverlayStateFromUrl from './useOverlay';
import useFeatureToggle from 'Client/hooks/useFeatureToggle';
import { AppBannerValues } from 'Common/appshell_types';
import useBrazeReady from 'Client/hooks/Braze/useBrazeReady';
import ShopToClubPageBlocker from 'Client/components/Overlays/ShopToClub/PageBlocker';
import useGa from 'Client/hooks/useGa';

const NewAccountFlyout = loadable(() => import('OneHeader/Overlays/NewAccountFlyout/index'), { ssr: false });
const ProductRatingsOverlay = loadable(() => import('Client/components/ProductDetailPage/Overlays/ProductRatings'));
const AppPushPopUpSmall = loadable(() => import('OneHeader/Overlays/AppPush/Small'));

const BellaOverlays = () => {
    const { p100AppBanner, p100SignupOverlayMicroFrontend, p100OnClickForceClubRegistrationPopup } = useFeatureToggle();
    useOverlayStateFromUrl();
    useBrazeReady();
    const overlayStateChecker = useOverlayStateChecker();
    const isNewAccountActive = overlayStateChecker(OverlayId.ACCOUNT_MENU);
    const isRatingOverlayActive = overlayStateChecker(OverlayId.RATE_YOUR_PRODUCT);

    const gaTracking = useGa();

    useEffect(() => {
        gaTracking.trackVariation('p100SignupOverlayMicroFrontend', p100SignupOverlayMicroFrontend);
    }, [gaTracking, p100SignupOverlayMicroFrontend]);

    return (
        <div>
            <LoginAndRegisterPopUp />
            <AccountFlyout />
            {isNewAccountActive && <NewAccountFlyout />}
            {p100SignupOverlayMicroFrontend ? (
                <SignupAndLoginMicroFrontend />
            ) : (
                <>
                    {p100OnClickForceClubRegistrationPopup && <ShopToClubPageBlocker />}
                    <ShopToClub overlayId={OverlayId.SHOP_TO_CLUB_REGISTRATION_SINGLE_STEP_OVERLAY} />
                    <ShopToClub overlayId={OverlayId.SHOP_TO_CLUB_REGISTRATION_MULTI_STEP_OVERLAY} />
                </>
            )}
            <ShopToClubDoubleOptIn />
            {isRatingOverlayActive && <ProductRatingsOverlay />}
            {p100AppBanner === AppBannerValues.small && <AppPushPopUpSmall />}
        </div>
    );
};

export default BellaOverlays;
